import React, { useEffect, useState } from "react";
import i18next from "i18next";
import { InfoIcon } from "../Icons";
import StoreHintPopup from "./StoreHintPopup";
import {
    getDeliveryTimes,
    getOpeningTimes,
} from "~/assets/js/Api/deliveryTimesApi";
import moment from "moment";
import { getFirstAvailableTimeslot } from "~/assets/js/Helpers/timeslot-utils";

const StoreHint = () => {
    const [popupOpen, setPopupOpen] = useState(false);
    const [firstDeliveryTime, setFirstDeliveryTime] = useState({});
    const [storeStatus, setStoreStatus] = useState("");

    const setStoreHintTitle = () => {
        switch (storeStatus) {
            case "open":
                return i18next.t("storeHint.open");
            case "closed":
                return i18next.t("storeHint.close.title");
            case "opening_soon":
                return i18next.t("storeHint.openingSoon.title");
        }
    };

    const setStoreHintSubTitle = () => {
        switch (storeStatus) {
            case "open":
                return i18next.t("storeHint.open");
            case "closed":
                return i18next.t("storeHint.close.subtitle");
            case "opening_soon":
                return i18next.t("storeHint.openingSoon.subtitle");
        }
    };

    useEffect(() => {
        const fetchTimeslotsFromApi = async () => {
            // Opening times for display
            const openingTimes = await getOpeningTimes();
            // for popup
            const deliveryTimes = await getDeliveryTimes();
            setFirstDeliveryTime(
                getFirstAvailableTimeslot(
                    deliveryTimes[Object.keys(deliveryTimes)[0]]
                )
            );
            const currentTime = moment();
            const startOfDay = currentTime.clone().startOf("day");
            const day = currentTime.format("dddd");
            const timeSinceMidnight = currentTime.diff(startOfDay, "seconds");
            const currentDay = openingTimes[day.toLowerCase()];

            currentDay?.forEach((slot) => {
                if (
                    slot.begin < timeSinceMidnight &&
                    slot.end > timeSinceMidnight
                ) {
                    return setStoreStatus(slot.status);
                }
            });
        };

        fetchTimeslotsFromApi();
    }, []);

    return (
        <>
            {firstDeliveryTime && (
                <StoreHintPopup
                    storeStatus={storeStatus}
                    open={popupOpen}
                    handleClose={() => setPopupOpen(false)}
                    firstDeliveryTime={firstDeliveryTime}
                />
            )}

            {storeStatus === "open" && (
                <div className={`store-hint store-hint__${storeStatus}`}>
                    <div className="store-hint__text">
                        <span className="store-hint__text-title">
                            {setStoreHintTitle()}
                        </span>
                    </div>
                </div>
            )}
            {storeStatus === "closed" && (
                <div
                    className={`store-hint store-hint__${storeStatus}`}
                    onClick={() => setPopupOpen(true)}
                >
                    <div className="store-hint__text">
                        <span className="store-hint__text-title">
                            {setStoreHintTitle()}
                        </span>
                        <span className="store-hint__text-subtitle">
                            {setStoreHintSubTitle()}
                        </span>
                    </div>
                    <div className="store-hint__icon">
                        <InfoIcon />
                    </div>
                </div>
            )}

            {storeStatus === "opening_soon" && (
                <div
                    className={`store-hint store-hint__${storeStatus}`}
                    onClick={() => setPopupOpen(true)}
                >
                    <div className="store-hint__text">
                        <span className="store-hint__text-title">
                            {setStoreHintTitle()}
                        </span>
                        <span className="store-hint__text-subtitle">
                            {setStoreHintSubTitle()}
                        </span>
                    </div>
                    <div className="store-hint__icon">
                        <InfoIcon />
                    </div>
                </div>
            )}
        </>
    );
};

export default StoreHint;
